import { Accordion, AccordionDetails, AccordionSummary, Grid, TextField, Typography } from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { DeliveryZonePlaceConfig, Place } from '../types/dtos';
import { ValidationErrorsType } from 'hooks/useForm';

type DeliveryZonePriceProps = {
    deliveryZonePlaceConfig: DeliveryZonePlaceConfig[];
    onChange: (id: string, newValue: string) => void;
    errors: ValidationErrorsType<Place> | undefined;
};

export const DeliveryZonePriceAccordion = ({ deliveryZonePlaceConfig, onChange, errors }: DeliveryZonePriceProps) => {
    const { t } = useTranslation();

    return (
        <Accordion>
            <AccordionSummary expandIcon={<GridExpandMoreIcon />} role="button">
                <Typography>{t('PLACE_FORM.LABEL_DELIVERY_ZONES_PRICES')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    {deliveryZonePlaceConfig.map((zone) => (
                        <Grid item xs={6} key={zone.id}>
                            <Grid container alignItems="center" spacing={2}>
                                <Grid item xs={8}>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            textAlign: 'left',
                                            lineHeight: '56px',
                                        }}
                                    >
                                        {zone.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        fullWidth
                                        value={zone.price?.toString() || ''}
                                        onChange={(e) => onChange(zone.id, e.target.value)}
                                        label={t('PLACE_FORM.LABEL_DELIVERY_ZONES_PRICE')}
                                        error={!!errors?.[`price-${zone.id}`]}
                                        helperText={errors?.[`price-${zone.id}`]?.errorMessage}
                                        variant="outlined"
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
